import React from 'react';
import { useLocation } from 'react-router-dom';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { sanitizeSpeedInsightsRoute } from '../../utils/speedInsightsRoute';

/**
 * Speed Insights avec route SPA réelle (sortir de « Unknown »).
 * Doit rester sous <Router>.
 */
export default function SpeedInsightsRoute() {
  const location = useLocation();
  const route = sanitizeSpeedInsightsRoute(location.pathname);
  return <SpeedInsights route={route} />;
}
